(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3558"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3558"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gUqxu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notifications = module.exports.default = void 0;
/*
 * This data is used by notification.js
 * 
 * Enqueue this file before notifications.js
 * 
 * Each notification object should have a title and body text
 * 
 */ const $c4f6766a06fd8d0e$var$notifications = module.exports.notifications = {
    login: {
        title: 'Login',
        body: 'You have successfully logged in.'
    },
    logout: {
        title: 'Log Out',
        body: 'You have successfully logged out.'
    },
    corporatesubscribed: {
        title: 'Subscribed',
        body: 'You have a active corporate subscription.'
    }
};
var $c4f6766a06fd8d0e$var$_default = module.exports.default = $c4f6766a06fd8d0e$var$notifications;

});

"use strict";
"use strict";
/**
 * @see /lib/adweek-patternlab-bootstrap/source/js/js-bottom/init.js
 */ !function(w, $) {
    // Initialize your code here. This is included at the very end of all of the JS
    function initializeGalleryMockup() {
        if ($ && $.fn && $.fn.galleryMockup) $('.gallery-footer').galleryMockup();
    }
    if ($('body').hasClass('single')) {
        if ($('body').hasClass('article-content-loaded')) {
            initializeGalleryMockup();
            console.log('initializeGalleryMockup called after .article-content-loaded in body tag');
        } else $(document).on('aw_article_content_loaded', function() {
            initializeGalleryMockup();
            console.log('initializeGalleryMockup called after aw_article_content_loaded');
        });
    } else {
        initializeGalleryMockup();
        console.log('initializeGalleryMockup called without aw_article_content_loaded');
    }
}(void 0, jQuery);


"use strict";
(function($) {
    'use strict';
    $(function() {
        /////////////////////////////////
        // Create notification markup
        let createNotificationMarkup = (notification)=>{
            if (typeof notification !== 'object' || typeof notification.title !== 'string' || typeof notification.body !== 'string') return '';
            let { title: title, body: body } = notification;
            // TO DO: Should replace this image
            let notifcationHeaderSrc = 'https://www.adweek.com/wp-content/themes/AdWeek/assets/images/icons/favicon.ico';
            let ntfMarkup = `

    <div aria-live="polite" aria-atomic="true" style="position: relative;">

        <div class="toast mt-3 initial-position" style="position: absolute; top: 0; right: 0;">
            <div class="toast-header">
                <img src="${notifcationHeaderSrc}" class="mr-2" alt="...">
                <strong class="mr-auto">${title}</strong>
                <small></small>
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body">
                ${body}
            </div>
        </div>
    
    </div>
    `;
            return ntfMarkup;
        };
        let currentUrl = new URL(window.location);
        let notificationTitle = 'Notification';
        let notificationBody, notificationData;
        let params = new URLSearchParams(currentUrl.search);
        notificationBody = params.get('ntfBody');
        notificationTitle = params.get('ntfTitle');
        notificationData = params.get('ntfData');
        if ((notificationBody || notificationData) && notificationData.length > 0) {
            let notificationMarkup = '';
            // Check for notification data in the url parameters
            if (notificationData && notificationData.length > 0) {
                var user_data = awGetUserData();
                if (notificationData == 'login' || notificationData == 'logout' || notificationData == 'corporatesubscribed') {
                    if (awIsUserLoggedIn() && notificationData == 'login' && Cookies.get('aw_login_msg') !== 'true') {
                        let notification = adw.notifications[notificationData];
                        notificationMarkup = createNotificationMarkup(notification);
                        Cookies.set('aw_login_msg', 'true', {
                            expires: 365
                        });
                        Cookies.set('aw_account_access', 'true', {
                            expires: 365
                        });
                        Cookies.remove('aw_logout_msg');
                    } else if (awIsUserLoggedIn() && notificationData == 'logout') console.log('User Not Logout Yet');
                    else if (!awIsUserLoggedIn() && notificationData == 'logout' && Cookies.get('aw_logout_msg') !== 'true' && Cookies.get('aw_account_access') == 'true') {
                        let notification = adw.notifications[notificationData];
                        notificationMarkup = createNotificationMarkup(notification);
                        Cookies.set('aw_logout_msg', 'true', {
                            expires: 365
                        });
                        Cookies.remove('aw_login_msg');
                    } else if (!awIsUserLoggedIn() && notificationData == 'login') console.log('User Not Login Yet');
                    else if (awIsUserLoggedIn() && notificationData == 'corporatesubscribed' && Cookies.get('aw_corporatesubscribed_msg') !== 'true') {
                        Cookies.set('aw_corporatesubscribed_msg', 'true', {
                            expires: 365
                        });
                        let notification = adw.notifications[notificationData];
                        notificationMarkup = createNotificationMarkup(notification);
                    }
                } else {
                    let notification = adw.notifications[notificationData];
                    notificationMarkup = createNotificationMarkup(notification);
                }
            }
            let showNotification = (markup)=>{
                let navbar;
                if (document.querySelector('#aw-navbar-root')) navbar = document.querySelector('#aw-navbar-root');
                else navbar = document.querySelector('.secondary-nav-container') ? document.querySelector('.secondary-nav-container') : document.querySelector('.navbar-wrapper');
                var notificationEl = document.createElement("div");
                notificationEl.classList = [
                    'container-fluid'
                ];
                notificationEl.innerHTML = markup;
                if (typeof navbar === 'object' && navbar !== 'null') navbar?.insertAdjacentElement?.('afterend', notificationEl);
                // Init Toast
                $('.toast').on('shown.bs.toast', function() {
                    // do something...
                    $('.toast').addClass('final-position');
                });
                $('.toast').toast({
                    autohide: true,
                    delay: 6000,
                    animation: true
                }).toast('show');
            };
            showNotification(notificationMarkup);
        }
    /////////////////////////////////
    });
})(jQuery);


"use strict";
var $7445254878aa97da$exports = {};
"use strict";
Object.defineProperty($7445254878aa97da$exports, "__esModule", {
    value: true
});
$7445254878aa97da$exports.getQuery = $7445254878aa97da$var$getQuery;
$7445254878aa97da$exports.getQueryMarkup = $7445254878aa97da$var$getQueryMarkup;
$7445254878aa97da$exports.getQueryandPaginationMarkupForSearch = $7445254878aa97da$var$getQueryandPaginationMarkupForSearch;
/**
 *
 * @example```js
 *   const queryObj = {
 *     "post_type": "post",
 *     "tax_query": {
 *       "taxonomy": "vertical",
 *       "field": "term_id",
 *       "terms": "4"
 *      }
 *    };
 *    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
 *
 *    getQuery(
 *      queryParam,
 *      'aw-text',
 *      'wide',
 *      true,
 *      'index_item'
 *    ).then( res => res.json() ).then( res => console.log(res) );
 *
 * ```
 * @param query
 * @param imageSize
 * @param premiumMarkupType
 * @param getPostData
 * @param getMarkup
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQuery(query, imageSize = '', premiumMarkupType = '', getPostData = true, getMarkup = '') {
    let url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}`;
    if (imageSize) url += `&image_size=${imageSize}`;
    if (premiumMarkupType) url += `&premium_markup_type=${premiumMarkupType}`;
    if (getPostData) url += `&get_post_data=${getPostData}`;
    if (getMarkup) url += `&get_markup=${getMarkup}`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query data: ' + e);
        throw e;
    }
}
/**
 *
 * @param query
 * @param getMarkup
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQueryMarkup(query, getMarkup) {
    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&get_markup=${getMarkup}&get_post_data=false&taxonomy=${adw.posts.taxonomy}`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query markup data: ' + e);
        throw e;
    }
}
/**
 *
 * @param {string} query - encoded and stringified JSON object
 * @param {string} requestUri
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQueryandPaginationMarkupForSearch(query, requestUri) {
    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&request_uri=${requestUri}&get_markup=index_item&get_post_data=false&pagination_markup=search_page_pagination`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query markup data: ' + e);
        throw e;
    }
}


function $d85cf3f75a12e207$var$onScroll(e) {
    var containerEl = e.target;
    var markup = containerEl.dataset.markup;
    var triggerLength = containerEl.dataset.triggerLength;
    var rawQueryInfo = containerEl.dataset.query;
    var queryInfo = JSON.parse(rawQueryInfo);
    const templateNode = containerEl.querySelector('.grid-scroller__item-container').cloneNode();
    if (containerEl.scrollLeft > triggerLength && containerEl.dataset.isLoading === 'false' && containerEl.dataset.isDone === 'false') {
        const spinnerNode = templateNode.cloneNode();
        const spinnerMarkup = '<div class="d-flex h-100 flex-column justify-content-center">\n  <div class="spinner-border text-danger" role="status">\n  <span class="sr-only">Loading...</span>\n</div>\n</div>';
        spinnerNode.insertAdjacentHTML('beforeend', spinnerMarkup);
        containerEl.appendChild(spinnerNode);
        containerEl.dataset.isLoading = true;
        (0, $7445254878aa97da$exports.getQueryMarkup)(rawQueryInfo, markup).then((res)=>res.json()).then((body)=>body.markup).then((markup)=>{
            spinnerNode.remove();
            if (markup && markup.length !== 0) {
                const templateNode = containerEl.querySelector('.grid-scroller__item-container').cloneNode();
                for(let i = 0; i < markup.length; i++){
                    const nodeToAppend = templateNode.cloneNode();
                    nodeToAppend.insertAdjacentHTML('beforeend', markup[i]);
                    containerEl.appendChild(nodeToAppend);
                }
                return true;
            } else return false;
        }).then((bool)=>{
            // Firing an event to run some code after the load is complete
            containerEl.dispatchEvent(new Event('aw_infinite_loading.complete', {
                'bubbles': true
            }));
            if (bool) {
                var newMaxScrollWidth = containerEl.scrollWidth - containerEl.clientWidth;
                queryInfo.offset = queryInfo.offset + queryInfo.posts_per_page;
                containerEl.dataset.triggerLength = newMaxScrollWidth - (newMaxScrollWidth - triggerLength) / 2;
                containerEl.dataset.query = JSON.stringify(queryInfo);
                containerEl.dataset.isLoading = false;
            } else {
                containerEl.dataset.isDone = true;
                containerEl.removeEventListener('scroll', $d85cf3f75a12e207$var$onScroll);
                containerEl.removeEventListener('click.scrollVW', $d85cf3f75a12e207$var$onScroll);
            }
        });
    }
}
var $d85cf3f75a12e207$var$containerEls = document.querySelectorAll('.grid-scroller .grid-scroller__container');
$d85cf3f75a12e207$var$containerEls.forEach(function(containerEl) {
    const queryInfo = JSON.parse(containerEl.dataset.query);
    const maxScrollWidth = containerEl.scrollWidth - containerEl.clientWidth;
    if (queryInfo.posts_per_page === containerEl.childElementCount) {
        containerEl.dataset.isLoading = false;
        containerEl.dataset.isDone = false;
        containerEl.dataset.triggerLength = maxScrollWidth / 2;
        queryInfo.offset = queryInfo.posts_per_page;
        queryInfo.posts_per_page = 200;
        containerEl.dataset.query = JSON.stringify(queryInfo);
        containerEl.addEventListener('scroll', $d85cf3f75a12e207$var$onScroll);
        containerEl.addEventListener('click.scrollVW', $d85cf3f75a12e207$var$onScroll);
    }
});


"use strict";
function $5dbece11096b6cf0$var$updatePostPublishUnixTimestamp() {
    const single_post = document.querySelector(".single-post, .single-contributor_content");
    if (single_post) {
        const publishTime = document.getElementsByClassName("custom-publish-time");
        if (publishTime && publishTime?.[0]) {
            const postPublishUnixTimestamp = publishTime[0].getAttribute("data-published-time");
            const postTimeOutput = awCalculateArticleTime(postPublishUnixTimestamp);
            publishTime[0].innerHTML = postTimeOutput;
        }
    }
    awUpdateArticleTimeOnCategoryPage();
}
document.addEventListener("DOMContentLoaded", $5dbece11096b6cf0$var$updatePostPublishUnixTimestamp);


"use strict";
(function($) {
    'use strict';
    let $article = jQuery('article.main-content');
    if ($article && $article.length) {
        const authors = $article.data('authors'), publishDate = $article.data('date'), postId = $('article').data('id'), featured = $article.data('featured'), categories = $article.data('categories'), vertical = $article.data('zone');
        const articleData = {
            'page': location.pathname,
            'documentTitle': document.title,
            'dimension1': authors,
            'dimension2': publishDate,
            'dimension3': postId,
            'dimension4': 1,
            'dimension5': featured,
            'dimension6': categories,
            'dimension7': vertical
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(articleData);
    }
    $(document).on('aw-location-detected', function(ev, locationData) {
        /* When we detect user location inside plugins/aw-sitewide/global/geoIP.php, pass it to Google Analytics. */ if (locationData && locationData.country && locationData.country.iso_code) {
            const userCountryCode = locationData.country.iso_code;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'country_detected',
                'country': userCountryCode
            });
        }
    });
})(jQuery);



var $fa616dbd1f1bc773$var$_notificationData = $fa616dbd1f1bc773$var$_interopRequireDefault((parcelRequire("gUqxu")));
"use strict";
// jQuery(function () {
window.addEventListener('DOMContentLoaded', function() {
    const loadAdsBasedOnDevice = ()=>{
        const isDefaultPostTemplate = document.querySelector('body').classList.contains('post-template-default');
        if (awIsMobile() && adw?.post?.post_type === 'post' && isDefaultPostTemplate) {
            // If device is mobile and
            // the post type is post
            // then load Ads as user scrolls
            let adsLoaded = false;
            // Test via a getter in the options object to see if the passive property is accessed
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, 'passive', {
                    get: function() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassive", null, opts);
                window.removeEventListener("testPassive", null, opts);
            } catch (e) {}
            // Use our detect's results. passive applied if supported, capture will be false either way.
            const listenerOptions = {
                once: true
            };
            if (supportsPassive) listenerOptions.passive = true;
            window.addEventListener('scroll', function() {
                console.log('Loading Ads...');
                if (!adsLoaded) {
                    loadAdsWithConfig();
                    adsLoaded = true;
                }
            }, listenerOptions);
        } else loadAdsWithConfig();
    };
    const loadAdsWithConfig = ()=>{
        if (typeof window.awLoadAds !== 'undefined') {
            if (typeof otGeoContinent !== 'undefined' && otGeoContinent === 'EU' && typeof OnetrustActiveGroups !== 'undefined') window.awLoadAds({
                usePersonalizedAds: OnetrustActiveGroups.includes('C0004')
            });
            else window.awLoadAds({
                usePersonalizedAds: true
            });
        } else console.error('awLoadAds is undefined');
    };
    (function($) {
        console.log('pre awLoadAds function call');
        if (!adw.is_user_logged_in) {
            // loadAdsBasedOnDevice();
            loadAdsWithConfig();
            window.lytics = window.lytics || {};
            window.lytics.fields = window.lytics.fields || {};
            var userCountryCode = 'unknown';
            var locationCookie = Cookies.get('locationCookie');
            var locationData = {
                ip: 'unknown',
                country: {
                    iso_code: 'unknown'
                }
            };
            function awProcessUserLocation(locationData) {
                if (locationData && locationData.country && locationData.country.iso_code) {
                    userCountryCode = locationData.country.iso_code;
                    $(document).trigger('aw-location-detected', locationData);
                }
                window.lytics.fields.attr_user_country_code = userCountryCode;
            }
            if (typeof locationCookie !== 'undefined') {
                var parsedCookie = JSON.parse(locationCookie);
                locationData.ip = parsedCookie.ip;
                locationData.country.iso_code = parsedCookie.country.iso_code;
                $(document).trigger('aw-ip-detected', locationData.ip);
                $('head').append('<meta name="ipaddr" value="' + locationData.ip + '" />');
                awProcessUserLocation(locationData);
            }
        } else if (typeof window.awLoadAds !== 'undefined') window.awLoadAds({
            usePersonalizedAds: true
        });
        else console.error('awLoadAds is undefined');
    })(jQuery);
});


"use strict";
(function($) {
    'use strict';
    $(window).on('load', function() {
        if ($("#wpcf7-f911187-p801333-o1").length) {
            var wpcf7Elm = document.querySelector('.wpcf7');
            wpcf7Elm.addEventListener('wpcf7submit', function(event) {
                var errorSpan = '<span class="wpcf7-not-valid-tip" aria-hidden="true">The field is required.</span>';
                if ("BusinessType" == event.detail.inputs[6].name && "" == event.detail.inputs[6].value) $(errorSpan).insertAfter('select[name="BusinessType"]');
                if ("Job-Level-Seniority" == event.detail.inputs[7].name && "" == event.detail.inputs[7].value) $(errorSpan).insertAfter('select[name="Job-Level-Seniority"]');
                if ("Job-Function" == event.detail.inputs[8].name && "" == event.detail.inputs[8].value) $(errorSpan).insertAfter('select[name="Job-Function"]');
            }, false);
            $('.wpcf7-submit').on('click', function(e) {
                $(".wpcf7-form-control").each(function() {
                    console.log($(this).val());
                    if ($(this).val() !== "") $(this).next().find("wpcf7-not-valid-tip").remove();
                });
                if ($('select[name="recipient"]').val() != "" && $('input[name="first_name"]').val() != "" && $('input[name="last_name"]').val() != "" && $('input[name="email"]').val() != "" && $('input[name="company"]').val() != "" && $('input[name="title"]').val() != "" && $('textarea[name="message"]').val() != "") {
                    var businessType = $('select[name="BusinessType"]').val();
                    if (businessType === '') e.preventDefault();
                    var jobLevelSeniority = $('select[name="Job-Level-Seniority"]').val();
                    if (jobLevelSeniority === '') e.preventDefault();
                    var jobFunction = $('select[name="Job-Function"]').val();
                    if (jobFunction === '') e.preventDefault();
                }
            });
        }
    });
})(jQuery);


function $fa616dbd1f1bc773$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
adw.notifications = $fa616dbd1f1bc773$var$_notificationData.default;

})();
//# sourceMappingURL=index.js.map
